import { observer } from 'mobx-react-lite'
import { type IRowBase, type ITableProps, type TableStore } from 'shared/ui/TableNew'
import { getAriaLabel } from 'shared/lib'
import { Checkbox } from 'shared/ui'
import {
  HeaderLeftContent,
  type IHeaderLeftContentProps,
} from 'shared/ui/TableNew/ui/TableRowHead/HeaderLeftContent/HeaderLeftContent'
import { HeaderRightContent } from 'shared/ui/TableNew/ui/TableRowHead/HeaderRightContent/HeaderRightContent'
import { HeaderCenterContent } from 'shared/ui/TableNew/ui/TableRowHead/HeaderCenterContent/HeaderCenterContent'
import styles from './styles.module.scss'

type IHeaderSelectedContentProps<TRow extends IRowBase> = {
  store: TableStore<TRow>
  headerLeftContentProps?: IHeaderLeftContentProps
  rightHeaderContent: ITableProps<TRow>['rightHeaderContent']
  withoutSelectedCount: boolean
  withActions?: boolean
  withSelectAll: ITableProps<TRow>['withSelectAll']
}

export const HeaderSelectedContent = observer(
  <TRow extends IRowBase>({
    store,
    headerLeftContentProps,
    withoutSelectedCount,
    rightHeaderContent,
    withActions,
    withSelectAll,
  }: IHeaderSelectedContentProps<TRow>) => {
    const { allVisibleRowsSelected, bulkStore, columnsStore } = store
    const { toggleSelectAll, isSelected, bulkAllMode } = bulkStore
    const { visibleColumnsIds } = columnsStore
    const selected = isSelected
    const toggleSelected = () => {
      toggleSelectAll()
    }
    const isRightContent = visibleColumnsIds || rightHeaderContent || withActions

    if (!selected && !withoutSelectedCount) return null

    return (
      <div className={styles.wrap}>
        <div className={styles.top}>
          <div className={styles.top__content}>
            <div
              className={styles.top__wrapCheckbox}
              aria-label={getAriaLabel('TableCheckboxHead', 'Selected')}
            >
              <Checkbox
                checked={selected}
                isIndeterminate={selected && !bulkAllMode && !allVisibleRowsSelected}
                onChange={toggleSelected}
              />
            </div>

            <HeaderLeftContent store={store} {...headerLeftContentProps} />
          </div>

          {isRightContent && (
            <HeaderRightContent store={store} rightHeaderContent={rightHeaderContent} />
          )}
        </div>

        {withSelectAll && selected && !withoutSelectedCount && (
          <div className={styles.bottom}>
            <HeaderCenterContent store={store} />
          </div>
        )}
      </div>
    )
  }
)
